import './styles/App.scss';
import Header from './components/common-header/Header';
import Hero2 from './components/Hero2';
import Video from './components/Video';
import Gallery from './components/Gallery';
import WhatToKnow from './components/WhatToKnow';
import Cta from './components/Cta';
import Footer from './components/common-footer/Footer';
import Reference from './components/Reference/Reference';

function App() {
  return (
    <div className="App">
      <Header clientName={'Enfamil'} />
      <Hero2 />
      <Video />
      <Gallery />
      <WhatToKnow />
      <Reference />
      <Cta />

      <Footer />
    </div>
  );
}

export default App;
